import StatEditor from "../../organisms/StatEditor";

const NewStat = () => {
  return <StatEditor headText="⚽️새 Stat 쌓기⚽️" isEdit={false} />;
};

export default NewStat;
